import React, { PureComponent, createRef, Fragment } from "react";
// import { nest } from "d3-collection";
import { group } from "d3-array";
import NavButtons from "../NavButtons";
import SocialButtons from "../SocialButtons";
import Classnames from "classnames";
import "./TextCard.scss";
import { section } from "../../global-interfaces";
import { generateCardID, generateURL, returnFormatSrtringArray } from "../../utils";
import headshot from "../../assets/amit_headshot.png";
import signature from "../../assets/amit_signature.svg";
import { CHART_TYPES } from "../../constants";
const { TEXT, NESTED_TEXT, HEADLINE } = CHART_TYPES

interface Props {
  type: string;
  data: Array<TextObject>;
  title: string;
  card: number;
  section: section;
  introCard: boolean;
  setSection: Function;
  observer: IntersectionObserver;
}

interface TextObject {
  label: string;
  label_group?: string;
  value?: number;
  column?: number;
}

interface NestedTextObject {
  key: number;
  values: Array<TextObject>;
}

class TextCard extends PureComponent<Props> {
  private cardRef: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);
    this.state = {};
    this.cardRef = createRef();
  }

  componentDidMount() {
    const { observer } = this.props;
    // attach observer
    if (this.cardRef.current) observer.observe(this.cardRef.current);
  }

  render() {
    const {
      type,
      data,
      title,
      card,
      section,
      introCard,
      setSection,
    } = this.props;

    const nestedData =
      type === NESTED_TEXT &&
      Array.from(
        group(
          data.map((d: TextObject) => ({
            ...d,
            column: d.value ? +d.value && +d.value * 10 - 10 : 0,
          })),
          (d: TextObject) => (d.value ? Math.floor(+d.value) : 0),
          //@ts-ignore
          (d: TextObject) => d.column
        ),
        ([key, value]) => [key, Array.from(value)]
      );

    return (
      <div
        className="TextCard"
        ref={this.cardRef}
        id={generateCardID(section, card)}
      >
        {title && <div className="title">{title}</div>}
        <div
          className={Classnames(section.color, {
            "nested-text-content": type === NESTED_TEXT,
            "text-content": type === TEXT,
            headline: type === HEADLINE,
          })}
        >
          {nestedData &&
            nestedData.map((d: any, i: number) => {
              let columns = d[1].length;
              return (
                <div
                  key={i}
                  className={Classnames("nested-row-section", `row-${i}`, {
                    "many-columns": columns > 1,
                  })}
                >
                  {d[1].map((column: any, j: number) => (
                    <div
                      key={j}
                      className={`column-${j + 1}`}
                      style={{
                        gridColumn: `${j + 1} / ${j + 2}`,
                      }}
                    >
                      {column[1].map((text: TextObject) => (
                        <div key={text.label} className={text.label_group}>
                          <span>{text.label}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              );
            })}
          {!nestedData && data && data.map((d, i) => {
            const content = returnFormatSrtringArray(d.label).map(([classKey, string], i) => 
              <span key={i} className={classKey}>{string}</span>)
            if (d.label_group === "list") {
              /* prevents line breaks on unordered list items */
              return <ul key={i} className={Classnames("text-section", d.label_group)}>{content}</ul>
            }
            else return <div key={i}
              className={Classnames("text-section", d.label_group)}
            >
              {content}
            </div>
            })}
          {introCard && (
            <Fragment>
              <div>
                <img src={headshot} className="headshot" height={80} />
                <img src={signature} className="signature" height={80} />
              </div>
              <div>
                <span className="bold">Amit Paley</span>
                <br />
                <span>CEO & Executive Director </span>
                <br />
                <span> The Trevor Project</span>
              </div>
              <NavButtons setSection={setSection} />
              <div>
                This report is also available in a
                <a
                  href="https://www.thetrevorproject.org/wp-content/uploads/2019/06/The-Trevor-Project-National-Survey-Results-2019.pdf"
                  target="_blank"
                > downloadable PDF here
                </a>
                . For 2020 National Survey, click <a
                  href="https://www.thetrevorproject.org/survey-2020/"
                  target="_blank"
                >here</a>.
              </div>
            </Fragment>
          )}
        </div>
        {(type === HEADLINE && card === 0) && <SocialButtons link={generateURL(section)} />}
      </div>
    );
  }
}

export default TextCard;
